import { get } from '..';

const getUserGroups = () => get('users/v2/user-groups');

export default getUserGroups;
